// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1NGks","boxTitle":"Qualiphy_boxTitle__zjz04","box":"Qualiphy_box__3BZ7u","toggleWrap":"Qualiphy_toggleWrap__3bU2A"};